import React, { Component } from 'react'
import { get } from 'lodash'

import ParticipantActionComponent from './ParticipantAction'
import BetaParticipantComponent from './ParticipantActions'
import SalesforceAction from './SalesforceAction'
import TargetedAccountsAction from './TargetedAccountsAction'
import LeandataAction from './LeandataAction'

import ACCESS from 'utils/Access'

class ActionEditor extends Component {
  render() {
    const { action } = get(this.props.rule, 'data.item')

    if (!action) {
      return null
    }

    return (
      <div className="rules-action-editor">
        {action.type === 'LEANDATA_PARTICIPANT' &&
          <LeandataAction {...this.props} />
        }
        { ACCESS.hasGates('has_beta_lead_routing') && action.type === 'PARTICIPANT' &&
          <BetaParticipantComponent {...this.props} />
        }
        { !ACCESS.hasGates('has_beta_lead_routing') && action.type === 'PARTICIPANT' &&
          <ParticipantActionComponent {...this.props}/>
        }
        { action.type === 'SALESFORCE_PARTICIPANT' &&
          <SalesforceAction {...this.props} />
        }
        { action.type === 'ABM_PARTICIPANT' && this.props.hasABM &&
          <TargetedAccountsAction {...this.props} />
        }
      </div>
    )
  }
}

export default ActionEditor



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/ActionEditor/index.js